import { BaseJsonSchema, createSchemaByBasicTypes } from "../../helpers";

export const ILongitude: BaseJsonSchema = {
  type: "object",
  properties: {
    sellerId: createSchemaByBasicTypes("string"),
  },
};
